export const ROUTE_HOME: string=`/`;
